import React, { useEffect, useState } from "react";
import _ from "lodash";
import { useOutletContext } from "react-router-dom";
import {
  ScienceOutlined,
  InfoTwoTone,
  SearchOutlined,
} from "@mui/icons-material";
import { Form, InputGroup } from "react-bootstrap";

import Tab from "components/Tab";
import CardList from "components/Card/CardList";
import LoadingModal from "components/LoadingModal";
import ModuleHeader from "components/Card/ModuleHeader";
import PaginatedTable from "components/PaginatedTable";

import { columns } from "./assets";
import ProjectManagementHOC from "./actions";
import { getTranslation } from "utils/renderLanguage";
import "./index.scss";

const ProjectManagement = (props) => {
  const outletContext = useOutletContext();
  const { language, user, onNavigate } = outletContext;
  const [selectedTab, setSelectedTab] = useState("Card View");

  useEffect(() => {
    props.getProjects(user.uid);
  }, []);

  const listViewColumns = [
    {
      header: getTranslation(language, "Project"),
      accessor: "project_name",
      containerStyle: { width: "40%" },
    },
    {
      header: getTranslation(language, "Implementing Agency"),
      accessor: "implementing_agency",
      containerStyle: { width: "30%" },
    },
    {
      header: getTranslation(language, "State"),
      accessor: "state",
      containerStyle: { width: "20%" },
    },
    {
      header: getTranslation(language, "Completion (%)"),
      containerStyle: { width: "20%" },
      renderColumn: (rowData) => {
        let currentKPI = 0;
        let targetKPI = 0;
        rowData.stage_and_milestone?.forEach((stage) => {
          stage.stage_milestone?.forEach((milestone) => {
            currentKPI += parseInt(milestone.milstone_actual_kpi || 0);
            targetKPI += parseInt(milestone.milstone_kpi || 0);
          });
        });
        const percentage =
          targetKPI > 0 ? ((currentKPI / targetKPI) * 100).toFixed(2) : 0;
        return <p>{percentage}%</p>;
      },
    },
  ];

  return (
    <>
      <ModuleHeader
        title={getTranslation(language, "Project Management")}
        description={getTranslation(
          language,
          "This module use to show all the project in the system and allow Project Leader to submit document and progress."
        )}
        actionButton={[]}
        renderIcon={() => <ScienceOutlined />}
      />
      <Tab
        selections={["Card View", "List View"]}
        selectedItem={selectedTab}
        onSelect={setSelectedTab}
      />
      <div style={{ marginBottom: "20px", marginTop: "20px" }}>
        <InputGroup>
          <InputGroup.Text>
            <SearchOutlined />
          </InputGroup.Text>
          <Form.Control
            type="text"
            placeholder={getTranslation(language, "Search by project name...")}
            value={props.searchQuery}
            onChange={(e) => props.handleSearch(e.target.value)}
          />
        </InputGroup>
      </div>
      {selectedTab === "Card View" && (
        <CardList
          columns={columns({
            selected_year: props.selected_year,
          })}
          data={props.searchProjectList || []}
          actions={[
            {
              label: (
                <>
                  <InfoTwoTone style={{ marginRight: 5 }} />
                  {getTranslation(language, "View")}
                </>
              ),
              onClick: (rowData) =>
                onNavigate(
                  `/dashboard/project-management/${rowData.project_id}`
                ),
            },
          ]}
        />
      )}
      {selectedTab === "List View" && (
        <PaginatedTable
          rowData={props.searchProjectList || []}
          columnData={listViewColumns}
          rowsPerPage={30}
          actionsColumn={[
            {
              name: "View",
              renderActionIcon: <InfoTwoTone />,
              onClick: (rowData) =>
                onNavigate(
                  `/dashboard/project-management/${rowData.project_id}`
                ),
            },
          ]}
        />
      )}
      {props.onLoadProjectManagement && <LoadingModal />}
    </>
  );
};

export default ProjectManagementHOC(ProjectManagement);
